module.exports = __webpack_public_path__ + "static/img/3.afa7c20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app/3.jpg
// module id = wBqP
// module chunks = 0